import { CommonModule } from '@angular/common';
import { booleanAttribute, ChangeDetectionStrategy, Component, HostBinding, Input } from '@angular/core';
import { GalaxyAvatarModule } from '@vendasta/galaxy/avatar';

import { TranslateModule } from '@ngx-translate/core';
import { ChatSourceId } from '@vendasta/galaxy/chat-composer';
import { ChatMessageComponent } from '../chat-message/chat-message.component';

@Component({
  selector: 'glxy-chat-message-group',
  imports: [CommonModule, GalaxyAvatarModule, ChatMessageComponent, TranslateModule],
  templateUrl: './chat-message-group.component.html',
  styleUrls: ['./chat-message-group.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ChatMessageGroupComponent {
  @HostBinding('class') class = 'glxy-chat-message-group';

  @Input() type: 'sent' | 'received' = 'received';

  @Input() messageFrom = '';

  @Input() messageMetadata?: string;

  @Input() profileIcon?: string;

  @Input() profilePicUrl?: string;

  @Input() profileSVGIcon?: string;

  @Input() profileBackgroundColor?: string;

  @Input() profileSourceIconName?: ChatSourceId;

  @Input() showProfilePic?: boolean | 'auto' = `auto`;

  @Input({ transform: booleanAttribute }) sentFromYou = false;

  @Input({ transform: booleanAttribute }) isTyping = false;

  @Input({ transform: booleanAttribute }) showReceivedMessageMetadata? = false;

  get shouldShowProfilePic(): boolean {
    return (
      this.showProfilePic === true ||
      (this.type === 'received' && this.showProfilePic !== false) ||
      (this.type === 'sent' && !this.sentFromYou && this.showProfilePic !== false)
    );
  }
}
